import { getEnvironmentSuffix } from "~/utils/regionUtil";

export const getRuntimeDomainName = (runtimeDomain: string, region?: string): string => {
    const environmentSubDomain = getEnvironmentSuffix(region);
    return `${runtimeDomain}${environmentSubDomain}.twil.io`;
};
